import { render } from "./Housing_Levy.vue?vue&type=template&id=3e5ffa27"
import script from "./Housing_Levy.vue?vue&type=script&lang=js"
export * from "./Housing_Levy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__